module.exports = __webpack_public_path__ + "img/right_angle_corner_line_icon.f1b808e2.svg";